module.exports = __webpack_public_path__ + "img/1532109008.fbcdbf0a.jpg";